<ng-template #iconContainer>
  @if (icon(); as icon) {
    <i [class]="cx('icon') + ' ' + icon"></i>
  }
  @if (iconTemplate(); as iconTemplate) {
    <ng-container *ngTemplateOutlet="iconTemplate" />
  }
</ng-template>
<a
  [routerLink]="routerLink()"
  [class]="cx('link')"
  [pTooltip]="isIconOnly() ? label() : undefined"
  [tooltipStyleClass]="cx('tooltip')"
  (click)="clicked.emit($event)"
>
  @if (icon() || iconTemplate()) {
    @if (badge()) {
      <p-overlaybadge [value]="badge()" severity="danger" badgeSize="small">
        <ng-container *ngTemplateOutlet="iconContainer" />
      </p-overlaybadge>
    } @else {
      <ng-container *ngTemplateOutlet="iconContainer" />
    }
  }
  @if (!iconOnly()) {
    <span [class]="cx('label')" [attr.data-label]="label()"> {{ label() }} </span>
  }
</a>
